import { Grid } from "@mui/material";
import Label from "../../../libs/rhf-mui/ui/Label";
import { useTranslation } from "react-i18next";

type Props = {
  text: string;
  margin_right?: string;
  fore_color?: string;
  bold: boolean;
  variant?: any;
};

const UcUniText = ({
  text,
  margin_right,
  fore_color,
  bold,
  variant,
}: Props) => {
  const texts = text.split("<br/>");
  const { t } = useTranslation();

  return (
    <Grid item sx={{ pt: "6px", pb: "3px", mr: margin_right }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {texts.map((text, idx) => (
          <Label color={fore_color} bold={bold} variant={variant} key={idx}>
            {t(text)}
          </Label>
        ))}
      </div>
    </Grid>
  );
};

export default UcUniText;
